import { requestWithQuery } from '../../../shared/api/utils/provider';
import { ApiResponse } from '../../../shared/api/utils/responseTransform';
import { IRiderAssistantDetails } from '../../types/riderAssistant';

export async function getRiderAssistantDetails(riderAssistantId: string): Promise<ApiResponse<IRiderAssistantDetails>> {
  return requestWithQuery({ url: `/care/rider_assistants/${riderAssistantId}`, method: 'GET' });
}
